<template>
  <div class="ca-tooltip" :class="clasesTooltip" @click="$emit('click')">
    <v-tooltip
      :bottom="posicion == 'abajo'"
      :content-class="contentClass"
      :disabled="disabled"
      :left="posicion == 'izquierda'"
      :max-width="max_width"
      :right="posicion == 'derecha'"
      :top="posicion == 'arriba'"
      :value="active"
      fixed
      offset-overflow
    >
      <template v-if="!customActivator" v-slot:activator="{ on }">
        <v-icon
          :class="{
            icon_hide: !mostrarIcono,
            'tooltip-ca-icon': mostrarIcono,
            'tooltip-ca-icon--dark': dark,
            ...clasesIndicador,
          }"
          :color="colorIcono"
          :size="esIndicador ? 12 : icon_size"
          v-on="on"
        >{{ iconoTooltip }}
        </v-icon>
      </template>

      <template v-slot:activator="{ on }" v-else>
        <div class="custom_activator_div" v-on="on">
          <slot name="customActivator"></slot>
        </div>
      </template>
      <div class="titulo-tooltip" v-if="datos.titulo">
        <v-icon>{{ iconoTooltip }}</v-icon>
        {{ datos.titulo }}
      </div>
      <div class="texto-tooltip" v-html="textoTooltip"></div>
      <slot name="customEjemplo">
        <div class="ejemplo-tooltip" v-if="datos.ejemplo">
          {{ datos.ejemplo }}
        </div>
      </slot>
    </v-tooltip>
  </div>
</template>
<script>
export default {
  props: {
    icono: {type: String, default: 'info'},
    icon_size: {type: Number, default: 24},
    colorIcono: {type: String, default: 'celeste-claro'},
    mostrarIcono: {type: Boolean, default: true},
    posicion: {type: String, default: 'abajo'},
    datos: {
      type: Object,
      default: function () {
        return {};
      },
    },
    max_width: {type: Number, default: 320},

    //Simplificacion para tooltips de solo texto
    soloTexto: {type: Boolean, default: false},
    texto: {type: String, default: null},

    //Tooltips de indicadores (para estados)
    esIndicador: {type: Boolean, default: false},
    estado: {type: String, default: 'ok'},

    //Activador personalizado
    customActivator: {type: Boolean, default: false}, //habilita el slot de 'customActivator'
    active: {type: Boolean, default: undefined}, //Habilitacion Externa, para mostrar tooltip sin hover
    customClass: {type: String, default: ''}, //Clases Extra
    dark: {type: Boolean, default: false},
    large: {type: Boolean, default: false},
  },
  computed: {
    contentClass() {
      let clases = this.customClass;
      if (this.large) {
        clases = clases + ' ' + 'ca-tooltip--large';
      }
      return 'tooltip-ca' + ' ' + clases;
    },
    textoTooltip() {
      if (this.soloTexto) {
        return this.texto;
      }
      return this.datos.texto;
    },
    iconoTooltip() {
      if (this.esIndicador) {
        return 'lens';
      }
      return this.icono;
    },
    clasesTooltip() {
      return {
        'tooltip-ca-indicador': this.esIndicador,
        'tooltip-ca-indicador--ok': this.esIndicador && this.estado === 'ok',
        'tooltip-ca-indicador--warning':
            this.esIndicador && this.estado === 'warning',
        'tooltip-ca-indicador--danger':
            this.esIndicador && this.estado === 'danger',
      };
    },
    clasesIndicador() {
      return {
        'ca-indicador': this.esIndicador,
        'ca-indicador--ok': this.esIndicador && this.estado === 'ok',
        'ca-indicador--warning': this.esIndicador && this.estado === 'warning',
        'ca-indicador--danger': this.esIndicador && this.estado === 'danger',
      };
    },

    /**
       * Se deshabilita si se setea no mostrar icono y no esta definido la activacion externa del tooltip
       * o si la habilitacion externa vale falso
       */
    disabled() {
      return this.active !== undefined ? !this.active : !this.mostrarIcono;
    },
  },
};
</script>
<style lang="scss">
  .ca-tooltip {
    display: inline;

    .icon_hide {
      opacity: 0;
      cursor: default;
    }

    .custom_activator_div {
      display: inline-block;
    }

    .tooltip-ca-icon {
      cursor: pointer;
      color: color(celeste-claro) !important;
      transition: color 0.5s ease-in-out;

      &:hover {
        color: color(primary) !important;
      }

      &.tooltip-ca-icon--dark:hover {
        color: color(blanco) !important;
      }
    }

    /** Indicador */
    .ca-indicador.v-icon {
      font-size: 12px;

      &.ca-indicador--ok {
        color: color(verde) !important;
      }

      &.ca-indicador--warning {
        color: color(warning) !important;
      }

      &.ca-indicador--danger {
        color: color(rojo) !important;
      }
    }
  }

  // Con vuetify 2.0 el slot activator no se muestra dentro de v-tooltip por lo que no es necesario mostrar el elemento
  .v-tooltip {
    display: none;
  }

  .v-tooltip__content {
    padding: 10px !important;
  }

  .tooltip-ca {
    opacity: 1 !important;
    z-index: 9999 !important; //Máximo Z-index definido en la plataforma, los tooltips tienen prioridad para dibujarse por sobre cualquier elemento del frontend.
    background-color: color(texto-oscuro);

    border-radius: 2px;
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 14px 3px rgba(0, 0, 0, 0.12),
    0 8px 10px 1px rgba(0, 0, 0, 0.14);
    font-size: 13px;
    font-weight: 500;

    .titulo-tooltip {
      display: flex;
      align-items: center;
      color: color(celeste-agua);
      margin-bottom: 5px;

      .v-icon {
        color: color(celeste-agua);
        font-size: 17px;
        margin-right: 10px;
      }
    }

    .texto-tooltip {
      color: color(blanco);
      line-height: 1.23;
      white-space: pre-line;
    }

    .ejemplo-tooltip {
      line-height: 1.23;
      margin-top: 10px;
      color: color(celeste-claro);
      white-space: pre-line;
    }
  }

  .ca-tooltip--large {
    padding: 20px !important;
    border-radius: 4px;
    box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14),
    0 3px 5px -1px rgba(0, 0, 0, 0.2) !important;
    background-color: color(gris-oscuro);

    .titulo-tooltip {
      margin-bottom: 0px !important;
      font-size: 13px;
      font-weight: bold;
    }
  }
</style>